import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import StudentRegistration from "../../pages/dashboard/StudentForm"
import AddClass from "../../pages/dashboard/AddClass";
import Section from "../../pages/dashboard/Section";
import Teacher from "../../pages/dashboard/Teacher";
import Activity from "../../pages/dashboard/StudentActivity"
import StudentActivityQuick from "../../pages/dashboard/StudentActivityQuick"
import ImagesStore from "../../pages/dashboard/ImagesStore"
import Calender from "../../pages/dashboard/Calender";
import ActivityDetails from "../../pages/dashboard/ActivityDetails";
import CalenderEvents from "../../pages/dashboard/CalelnderEvents"
import CreateEvents from "../../pages/dashboard/CreateEvents"
import ActivityTabel from "../../pages/dashboard/ActivityTabel"
import ActivityReport from "../../pages/dashboard/ActivityReport"
import ParentActivity from "../../pages/dashboard/ParentActivity"
import ActivityTrackerTable from "../../pages/dashboard/ActivityTrackerTable"
import ParentActivityTrackerTable from "../../pages/dashboard/ParentActivityTrackerTable"
import ActivityAnalysis from "../../pages/dashboard/ActivityAnalysis"
import ActivityAnalysisAdmin from "../../pages/dashboard/ActivityAnalysisAdmin"
import StudentStory from "../../pages/dashboard/StudentStory"
import ParentMilestonesMemories from "../../pages/dashboard/ParentMilestonesMemories"
      import TeacherNotes from "../../pages/dashboard/TeacherNotes"
      import Fee from "../../pages/dashboard/Fee"
      // import FeeMaster from "../../pages/dashboard/FeeMaster"
      import ParentFee from "../../pages/dashboard/ParentFee"
import ParentStudentProfile from "../../pages/dashboard/ParentStudentProfile"
import UpgradePlan from "../../pages/dashboard/UpgradePlan"
import StudentChargeMaster from "../../pages/dashboard/StudentChargeMaster"
import PaymentFailed from "../../pages/dashboard/PaymentFailed"
import AcademicYear from "../../pages/dashboard/AcademicYear"
import SuperActivity from "../../pages/dashboard/SuperActivity"
import SubActivity from "../../pages/dashboard/SubActivity"
import ActivityExpected from "../../pages/dashboard/ActivityExpected"
import Attendence from "../../pages/dashboard/Attendence"
import StudentDetails from "../../pages/dashboard/StudentDetails"
import SchoolDetails from "../../pages/dashboard/SchoolDetails"
import Event from "../../pages/dashboard/Event"
import Lesson from "../../pages/dashboard/Lesson"
import LearnMore from "../../pages/dashboard/LernMore"
import Subject from "../../pages/dashboard/Subject"
import Schedule from "../../pages/dashboard/Schedule"
import Note from "../../pages/dashboard/Note"
import NoteList from "../../pages/dashboard/NoteList"
import Trainer from "../../pages/dashboard/Trainer"
import TrainingSession from "../../pages/dashboard/TrainingSession"
import TrainerRegistration from "../../pages/dashboard/TrainerRegistartion"
import DayReport from "../../pages/dashboard/DayReport"
import helpfullinformation from "../../pages/dashboard/HelpfullInformation"

import CalenderAssignment from "../../pages/dashboard/CalenderAssignment"
import CalenderAssignmentAddImages from "../../pages/dashboard/CalenderAssignmentAddImages"
import Assignment from "../../pages/dashboard/Assignment"
import Reports from "../../pages/dashboard/reports"
import AgeReports from "../../pages/dashboard/AgeReports"
import SpecialObservation from "../../pages/dashboard/SpecialObservation"
import Sound from "../../pages/dashboard/Sound"
import SoundMaster from "../../pages/dashboard/SoundMaster"
import CursiveMaster from "../../pages/dashboard/CursiveMaster"
import CursiveMasters from "../../pages/dashboard/CursiveMasters"
import Cursive from "../../pages/dashboard/cursive"
import MovableMaster from "../../pages/dashboard/MoovableMaster"
import IconMaster from "../../pages/dashboard/IconMaster"

import ReportOfActivities from "../../pages/dashboard/reportofactivities"
import MovableAlphabets from "../../pages/dashboard/MovableAlphabets"
import { Box, IconButton, Link } from '@material-ui/core'
import Icon from '@mdi/react'
// import Vendor from "../../pages/vendor";
// import VendorRegistration from "../../pages/vendor/VendorRegistration";
// import Locality from "../../pages/dashboard/Locality/Locality";
// import Categories from "../../pages/dashboard/components/Categories/Categories";
// import Menu from "../../pages/dashboard/components/Menu/Menu"
// import VendorList from "../../pages/dashboard/components/VendorList/VendorList"
// import OrderDetailes from "../../pages/dashboard/components/OrderDetailes/OrderDetailes"
// import DicountCoupon from "../../pages/dashboard/components/DiscountCoupon/DiscountCoupon";
//icons
import {
  mdiFacebook as FacebookIcon,
  mdiTwitter as TwitterIcon,
  mdiGithub as GithubIcon,
} from '@mdi/js'

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from "../../pages/dashboard/SchoolRegistration";
import Typography from "../../pages/typography";
import Notifications from "../../pages/notifications";
import Maps from "../../pages/maps";
import Icons from "../../pages/icons";
import Charts from "../../pages/charts";
// context
import { useLayoutState } from "../../context/LayoutContext";

import { Category } from "@material-ui/icons";
import SchooRegistration from "../../pages/dashboard/SchoolRegistration";
import ActivityService from "../../pages/dashboard/Locality/Service/activityService";
import TeacherLesson from "../../pages/dashboard/TeacherLesson";
import AddBranchSchool from "../../pages/dashboard/AddBranchSchool";
import EnquiryAdmin from "../../pages/dashboard/EnquiryAdmin";
import FoodMaster from "../../pages/dashboard/FoodMaster";
import SchoolFoodMenu from "../../pages/dashboard/SchoolFoodMenu";
import ParentFoodMenu from "../../pages/dashboard/ParentFoodMenu";
import SchoolHandbook from "../../pages/dashboard/SchoolHandbook";
import ParentHandbook from "../../pages/dashboard/ParentHandbook";
import PushNotificationAdmin from "../../pages/dashboard/PushNotificationAdmin";
import ParentNotifications from "../../pages/dashboard/ParentNotifications";
import Promotion from "../../pages/dashboard/Promotion";
import TeacherReportRatings from "../../pages/dashboard/TeacherReportRatings";
import UsersAndRoles from "../../pages/dashboard/UsersAndRoles";
import Unauthorized from "../../pages/dashboard/Unauthorized";
import RbacGuard from "../RbacGuard/RbacGuard";
import ParentSchoolBanner from "../ParentSchoolBanner/ParentSchoolBanner";
function Layout(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
      <>
        <Header history={props.history} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <ParentSchoolBanner history={props.history} />
          <RbacGuard>
          <Switch>
            <Route path="/app/unauthorized" component={Unauthorized} />
            <Route exact path="/app/dashboard" render={() => <Redirect to="/app/addbranchschool" />} />
            <Route path="/app/studentregistration/:id" component={StudentRegistration} />
            <Route path="/app/addclass" component={AddClass} />
            <Route path="/app/section" component={Section} />
                        <Route path="/app/activitytrackertable" component={ActivityTrackerTable} />
                        <Route path="/app/helpfullinformation" component={helpfullinformation} />
                        <Route path="/app/parentactivitytrackertable" component={ParentActivityTrackerTable} />
                        <Route path="/app/teachernotes" component={TeacherNotes} />
            <Route path="/app/teacher-report-ratings" component={TeacherReportRatings} />
            <Route path="/app/imagesstore" component={ImagesStore} />
            <Route path="/app/teacher" component={Teacher} />
            <Route path="/app/studentactivity" component={Activity} />
            <Route path="/app/quickactivity" component={StudentActivityQuick} />
            <Route path="/app/activitytabel" component={ActivityTabel} />
            <Route path="/app/activityexpected" component={ActivityExpected} />
            <Route path="/app/event" component={Event} />
            <Route path="/app/assignment" component={Assignment} />
            <Route path="/app/superactivity" component={SuperActivity} />
            <Route path="/app/subactivity" component={SubActivity} />
            <Route path="/app/attendence" component={Attendence} />
            <Route path="/app/studentdetails" component={StudentDetails} />
            <Route path="/app/schooldetails" component={SchoolDetails} />
            <Route path="/app/activityanalysis" component={ActivityAnalysis} />
                        <Route path="/app/keywiseactivity" component={ActivityAnalysisAdmin} />
                        <Route path="/app/fee" component={Fee} />
                        {/* <Route path="/app/feemaster" component={FeeMaster} /> */}
                        <Route path="/app/parentfee" component={ParentFee} />
            <Route path="/app/parent-student-profile" component={ParentStudentProfile} />
            <Route path="/app/upgrade-plan" component={UpgradePlan} />
            <Route path="/app/payment-failed" component={PaymentFailed} />
            <Route path="/app/student-charge-master" component={StudentChargeMaster} />
            <Route path="/app/users-and-roles" component={UsersAndRoles} />

            <Route exact path="/app/calenderassignment/:eventId/add-images" component={CalenderAssignmentAddImages} />
            <Route exact path="/app/calenderassignment" component={CalenderAssignment} />
            <Route path="/app/typography" component={Typography} />
            <Route path="/app/notifications" component={Notifications} />
            <Route path="/app/calenderevents" component={CalenderEvents} />
            <Route path="/app/studentEvents" component={Calender} />
            <Route path="/app/activitydetails/:id" component={ActivityDetails} />
            <Route path="/app/createevents" component={CreateEvents} />
            <Route path="/app/agereports" component={AgeReports} />
            <Route path="/app/activityreport" component={ActivityReport} />
            <Route path="/app/parentactivity" component={ParentActivity} />
            <Route path="/app/trainer" component={Trainer} />
            <Route path="/app/trainingsession" component={TrainingSession} />
            <Route path="/app/registrationtrainer" component={TrainerRegistration} />
            <Route path="/app/dayreport" component={DayReport} />
            <Route path="/app/studentstory" component={StudentStory} />
            <Route path="/app/milestones-memories" component={ParentMilestonesMemories} />
<Route path="/app/academicyear" component={AcademicYear} />
            <Route path="/app/specialobservation" component={SpecialObservation} />
            <Route path="/app/sound" component={Sound} />
            <Route path="/app/soundmaster" component={SoundMaster} />
                        <Route path="/app/cursivemaster" component={CursiveMaster} />
                        <Route path="/app/cursivemasters" component={CursiveMasters} />
            <Route path="/app/cursive" component={Cursive} />

            <Route path="/app/movablemaster" component={MovableMaster} />
            <Route path="/app/iconmaster" component={IconMaster} />
            <Route path="/app/lesson" component={Lesson} />
            <Route path="/app/teacherlesson" component={TeacherLesson} />
            <Route path="/app/learnmore" component={LearnMore} />
            <Route path="/app/subject" component={Subject} />
            <Route path="/app/schedule" component={Schedule} />
            <Route path="/app/promotion" component={Promotion} />
            <Route path="/app/note" component={Note} />
            <Route path="/app/notelist" component={NoteList} />
            <Route path="/app/enquiry" component={EnquiryAdmin} />
            <Route path="/app/foodmaster" component={FoodMaster} />
            <Route path="/app/foodmenu" component={SchoolFoodMenu} />
            <Route path="/app/parentfoodmenu" component={ParentFoodMenu} />
            <Route path="/app/handbook" component={SchoolHandbook} />
            <Route path="/app/parenthandbook" component={ParentHandbook} />
            <Route path="/app/push-notifications" component={PushNotificationAdmin} />
            <Route path="/app/parent-notifications" component={ParentNotifications} />

            <Route path="/app/addbranchschool" component={AddBranchSchool} />

            <Route path="/app/movablealphabets" component={MovableAlphabets} />
            {/* <Route path="/app/reports" component={Reports} /> */}
            {/* <Route path="/app/vendor" component={Vendor} />
              <Route path="/app/vendorregistration/:id" component={VendorRegistration} />
              <Route path="/app/locality" component={Locality} />
              <Route path="/app/categories" component={Categories} />
              <Route path="/app/menu" component={Menu} />
              <Route path="/app/listvendor" component={VendorList} />
              <Route path="/app/orderdetailes" component={OrderDetailes} />
              <Route path="/app/discountcoupon" component={DicountCoupon} /> */}
            <Route
              exact
              path="/app/ui"
              render={() => <Redirect to="/app/ui/icons" />}
            />
            <Route path="/app/reports" component={Reports} />
            <Route path="/app/reportofactivities" component={ReportOfActivities} />
            <Route path="/app/ui/reportofactivities" component={Icons} />
            <Route path="/app/ui/charts" component={Charts} />
          </Switch>
          </RbacGuard>
          <Box
            mt={5}
            width={"100%"}
            display={"flex"}
            alignItems={"center"}
            justifyContent="space-between"
          >
            {/* <div>
                <Link
                  color={'primary'}
                  href={'https://flatlogic.com/'}
                  target={'_blank'}
                  className={classes.link}
                >
                  Flatlogic
                </Link>
                <Link
                  color={'primary'}
                  href={'https://flatlogic.com/about'}
                  target={'_blank'}
                  className={classes.link}
                >
                  About Us
                </Link>
                <Link
                  color={'primary'}
                  href={'https://flatlogic.com/blog'}
                  target={'_blank'}
                  className={classes.link}
                >
                  Blog
                </Link>
              </div> */}
            <div>
              {/* <Link
                  href={'https://www.facebook.com/flatlogic'}
                  target={'_blank'}
                >
                  <IconButton aria-label="facebook">
                    <Icon
                      path={FacebookIcon}
                      size={1}
                      color="#6E6E6E99"
                    />
                  </IconButton>
                </Link> */}

            </div>
          </Box>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
